import { assert_string_object_id, assert_type_boolean, assert_type_enum } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ENUM__workspace_entity } from '../_enums/ENUM__workspace_entity';

export class RequestWorkspaceChildEntityUpdateShareStatus extends DTO__base {
  static _class_name_static: string = ENUM__dto_class_name.REQUEST_WORKSPACE_CHILD_ENTITY_UPDATE_SHARE_STATUS;

  workspace_id!: string;
  entity_type!: string;
  entity_id!: string;
  is_shared!: boolean;

  /*
   * METHODS
   */
  assert_standard_fields(): void {
    assert_string_object_id(this.workspace_id);
    assert_type_enum(this.entity_type, ENUM__workspace_entity);
    assert_string_object_id(this.entity_id);
    assert_type_boolean(this.is_shared);
  }
}
